import React, { Component } from "react";
import api from "../../services/api";

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";



import Moment from 'moment';
import 'moment/locale/pt';
import './styles.css';

import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';

import { Link } from 'react-router-dom';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default class UsersUnidades extends Component {


    state = {
      unidadenegocio_id : [],
      unidadesnegocios : [],
      users: [],
      usersInfo: [],
      open: true,
      };
    
      async componentDidMount(){   
        this.loadUsersUnidades();    
        const { id } = this.props.match.params;     
        const response = await api.get(`/api/unidadesnegocios/${id}`);
        this.setState ({
          unidadenegocio_id: response.data,
        }); 
        const { unidadenegocio_id } = this.state;
        const id2 = unidadenegocio_id._id;  
        const response2 = await api.get(`/api/users_select/${id2}`);
        this.setState ({
          unidadesnegocios: response2.data,
        }); 
      };

      loadUsersUnidades = async (page = 1) => {
        const { id } = this.props.match.params;  
        const response = await api.get(`/api/users_select/${id}?page=${page}`);  
        const { ...usersInfo } = response.data;
        this.setState({
          users: response.data,
          usersInfo,
           page  
        });
      };

      prevPage = () => {
        const { page } = this.state;
        if (page === 1) return;
        const pageNumber = page - 1;
        this.loadUsersUnidades(pageNumber);
      };
    
      nextPage = () => {
        const { page, usersInfo } = this.state;
        if (page === usersInfo.pages) return;
        const pageNumber = page + 1;
        this.loadUsersUnidades(pageNumber);
      };
     

    render() {
        const { unidadenegocio_id, open, unidadesnegocios, users } = this.state;
        return (
      
          <Dialog fullScreen open={open} TransitionComponent={Transition}>
          <AppBar className="appBar" style={{backgroundColor:unidadenegocio_id.cor}} backgroundColor={unidadenegocio_id.cor}>
            <Toolbar>
              
              <table style={{width:"100%"}}>
                <tr>
                  <td align="left"><Typography variant="h6" className="title" style={{textTransform:"none"}}>
                    &nbsp; {unidadenegocio_id.unidadenegocio} / Usuários ({unidadesnegocios.length})&nbsp;&nbsp;&nbsp;



                  </Typography>
                 
              </td>
                  <td align="right">
                    <Link to={`/admin/usuarios`}>
                  <IconButton edge="start" style={{color:'#fff'}} aria-label="close">
                    <CloseIcon />
                  </IconButton>
                  </Link>
              </td>
                </tr>
              </table>
                   
            </Toolbar>
          </AppBar>
      <br />&nbsp;
          <GridContainer style={{padding:30,}}>  

           <GridItem xs={12} sm={12} md={12}>
                      <div align="right" style={{marginBottom:20, marginTop:20,}}>
                      <Link style={{
                      backgroundColor:`${unidadenegocio_id.cor}`,   
                      height: 42,
                      borderRadius: 5,
                      color: '#fff',
                      fontSize: 14,
                      textDecoration: 'none',
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: 10,
                      paddingLeft: 30,
                      paddingRight: 35,
                      fontWeight:400
                      }} to={`/addusers/${unidadenegocio_id._id}`}>+ Criar usuário</Link>
                    </div>
                  </GridItem>


          {users.map(users => (
        <GridItem xs={12} sm={12} md={3} key={users._id}>
        <div className="doadores-list">
            <article >
            
              <p style={{fontSize:14, color:"#333"}}>
                Criado em <strong>{Moment(users.createdAt).format('L')}</strong>
              </p>

             
         
              <strong style={{color:unidadenegocio_id.cor, fontWeight:600}}>
              {users.nome}
              </strong>
       
  
              <p style={{fontSize:14,}}>
              {users.email}
              </p>
  
             
         
              <Link style={{borderColor:unidadenegocio_id.cor, backgroundColor:unidadenegocio_id.cor, color:"#FFF", fontSize:14, fontWeight:400}} to={`/edituser/${users._id}`}>Alterar</Link>
         
          
            </article>
            </div>          
                
           </GridItem>
           
             ))} 


         
         </GridContainer>   
         

        

        </Dialog>
          
       
        );
    }
}